/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * todo
 * 1. 增加参数控制是否分页，默认分页
 * 2. 样式优化

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [""];
export { styles as styles };
